<style lang="scss">
.loading {
  //border:1px solid red;
  padding: 10px 20px;
  font-size: 14px;
}
.skilltable {
  padding: 20px 15px;
  //border: 1px solid $c-dark-grey;
  border-top: none;
  .smalltext {
    //border:1px solid red;
    [class*='col-'] {
      //border:1px solid blue;
      padding-top: 3px;
      padding-bottom: 3px;
    }
  }

  &.personal {
    .active {
      transition: none;
    }

    button .smdtooltip {
      top: 0;
      left: 0;
    }

    .udropdowncontainer {
      .label {
        padding: 5px;
      }
      &.active {
        border-bottom: 3px solid $c-blue !important;
      }
    }
  }

  &.company,
  &.unit {
    .header {
      .smdtooltip {
        top: 0;
        left: 0;
      }

      margin-bottom: 5px;
    }
  }

  .skill {
    height: 50px;
  }

  .hoverable {
    cursor: pointer;
    transition: 0.2s all;

    &.hovered {
      background-color: $c-medium-grey;
      transform: scale(1);
    }
  }

  .highlight {
    color: $c-dark-blue;
    font-weight: bold;
  }

  .colortable > *,
  .bartable > * {
    padding-top: 7px;
    padding-bottom: 7px;
  }

  .color {
    background-color: $c-dark-blue;
  }

  .left-border {
    border-left: 2px solid $c-dark-grey;
  }
  .arrow {
    svg {
      position: relative;
      top: -2px;
    }
  }

  .filterbuttons {
    display: flex;
    gap: 15px;
    align-items: center;

    button {
      font-weight: bold;
      width: auto !important;

      border: 0 !important;
      padding: 2px !important;
      color: $c-dark-grey !important;

      &.active {
        color: $c-blue !important;
        border-color: $c-medium-blue !important;
        border-bottom: 3px solid $c-blue !important;
      }
    }
  }
  .namecontainer {
    .name {
      font-family: 'Helvetica Neue LT W05 65 Medium';
    }
  }

  .legendlink {
    color: $c-dark-blue;
    cursor: pointer;
    text-decoration: underline;
    text-align: center;
  }
}
</style>

<template>
  <div class="loading" v-if="loading">
    <!-- <div class="spinner-border mt-3" role="status"></div> -->
    <div>Daten werden geladen...</div>
  </div>
  <!--- Company / Unit Tables -->
  <div class="skilltable" :class="type" v-if="type != 'personal' && !loading" ref="container">
    <div class="row smalltext header" ref="header" :class="{ fixed }">
      <div class="col-12">
        <div class="row mb-3 scroller">
          <div class="col-4"></div>
          <div class="col-3" v-if="showScroller">
            <button class="arrow" @click="left()"><Icon :path="mdiArrowLeft" :width="15" :height="15" /></button>
          </div>
          <div class="col-3" v-if="showScroller">
            <button class="arrow" @click="right()"><Icon :path="mdiArrowRight" :width="15" :height="15" /></button>
          </div>
        </div>
      </div>
      <div class="col-4 align-self-center">{{ fixed ? title : 'Skills' }}</div>
      <div
        class="col-1 align-self-center headline hoverable"
        v-for="label in slicedMatrixLabels"
        :key="label"
        @mouseover="onMouseOver(label.id)"
        @mouseleave="onMouseLeave"
        :class="{ hovered: hovered == label.id, highlight: label.highlight }"
        @click="navigate(label.id)"
      >
        {{ label.name }}
      </div>
      <div class="col-1 align-self-center" :class="sumoffset > 0 ? `offset-${sumoffset}` : ''">
        <Tooltip :text="`Istwert ${type == 'unit' ? 'Abteilung' : 'Unternehmen'}`">Summe der Punkte geteilt durch die Anzahl</Tooltip>
      </div>
      <div class="col-1 align-self-center">
        <Tooltip :text="`Zielwert ${type == 'unit' ? 'Abteilung' : 'Unternehmen'}`">Summe der Zielwerte geteilt durch die Anzahl</Tooltip>
      </div>
    </div>
    <div class="row colortable" :key="skill.id" v-for="skill in skills">
      <div class="col-4">
        <Skill
          :skill="skill"
          :isFuture="(skill.future && type == 'company' && skill.future.length > 0) || (type == 'unit' && skill.future.includes(unit))"
          :isStrategic="(skill.strategic && type == 'company' && skill.strategic.length > 0) || (type == 'unit' && skill.strategic.includes(unit))"
        />
      </div>
      <div
        class="col-1 hoverable"
        v-for="label in slicedMatrixLabels"
        :key="label"
        @mouseover="onMouseOver(label.id)"
        @mouseleave="onMouseLeave"
        :class="{ hovered: hovered == label.id }"
        @click="navigate(label.id)"
      >
        <SkillColor :value="matrixTable[skill.id]?.values[label.id]?.value || -1" />
      </div>
      <div class="col-1 left-border" :class="sumoffset > 0 ? `offset-${sumoffset}` : ''">
        <SkillColor :value="matrixTable[skill.id]?.value || -1" />
      </div>

      <div class="col-1">
        <SkillColor :value="matrixTable[skill.id]?.target || -1" />
      </div>
    </div>
    <div class="row mt-3 scroller" v-if="showScroller">
      <div class="col-3 offset-4">
        <button class="arrow" @click="left()"><Icon :path="mdiArrowLeft" :width="15" :height="15" /></button>
      </div>
      <div class="col-3">
        <button class="arrow" @click="right()"><Icon :path="mdiArrowRight" :width="15" :height="15" /></button>
      </div>
    </div>
  </div>
  <!--- Company / Unit Tables END -->

  <!--- Personal Bar Table -->
  <div class="skilltable" :class="type" v-if="type == 'personal' && !loading" ref="container">
    <div class="row header" ref="header" :class="{ fixed }">
      <div class="col-12">
        <div class="row mt-3">
          <div class="col-12 namecontainer">
            <div v-if="fixed">
              <div class="name" v-if="name != ''">{{ name }}</div>
              {{ title }}
            </div>
          </div>
          <div class="offset-6 col-6 mt-2 mb-2 filterbuttons">
            <UserDropdown
              withbackevent
              class="button"
              v-if="gradingusers.length > 0"
              :users="gradingusers"
              @changed="filterTable"
              :class="{ active: barTableFilter != 'avg' && barTableFilter != 'self' && barTableFilter != 'manager' && barTableFilter != 'set' }"
            />
            <button @click="filterTable('avg')" :class="{ active: barTableFilter == 'avg' }">
              <Tooltip text="360° Feedback"
                >Durschnitt aller Einschätzungen, die für den Skill abgegeben wurden, inklusive Führungskraft und Selbsteinschätzung.</Tooltip
              >
            </button>
            <button @click="filterTable('set')" :class="{ active: barTableFilter == 'set' }">Abgestimmter Wert</button>
            <!-- <button @click="filterTable('self')" :class="{ active: barTableFilter == 'self' }">Meine Selbsteinschätzng</button>
            <button
              @click="filterTable('manager')"
              :class="{ active: barTableFilter == 'manager' }"
              v-hasperms="['user.all.manage', 'user.unit.manage', 'user.allbutceo.manage']"
            >
              Einschätzung Vorgesetze:r
            </button> -->
          </div>
        </div>
      </div>
    </div>

    <!-- {{ filteredBarTable }} -->

    <div class="row bartable" :key="`${skill}`" v-for="skill in skills">
      <div class="col-4"><Skill :skill="skill" /></div>

      <div class="col-8">
        <Bar
          :value="filteredBarTable[skill.id].value"
          :target="filteredBarTable[skill.id].target"
          :history="filteredBarTable[skill.id].history"
          v-if="filteredBarTable[skill.id]"
        />
      </div>
    </div>
  </div>
  <!--- Personal Bar Table END -->
</template>

<script lang="ts">
import { defineComponent, computed, ref, onMounted, onUnmounted, nextTick, inject } from 'vue';

import Bar from './Bar.vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import { mdiArrowLeft, mdiArrowRight } from '@mdi/js';

import UserDropdown from './custom/UserDropdown.vue';
import { Emitter } from 'mitt';

type GradeResult = {
  target?: number;
  set?: number;
  value?: number;
  leader?: number;
  self?: number;
  history?: number;
  detailed?: {
    [propName: number]: number;
  };
};

export default defineComponent({
  props: {
    skills: { type: Object, required: true },
    type: { type: String, default: 'personal' },
    unit: { type: Number },
    title: { type: String, required: true },
    name: { type: String, default: '' },
  },
  components: {
    Bar,
    UserDropdown,
  },
  setup(props) {
    const store = useStore();
    const router = useRouter();
    const sliceoffset = ref(0);
    const hovered = ref(-1);
    const barTableFilter = ref('avg');
    const barTable = ref<{ [propName: number]: GradeResult }>({});
    const table = ref<{ result: any; labels: any }>({ result: [], labels: [] });
    const header = ref();
    const container = ref();
    const fixed = ref(false);

    const loading = ref(true);

    const scrollhandler = () => {
      if (loading.value == false) {
        const headeroffset = (container.value as HTMLElement).offsetTop + 20;
        if (
          document.documentElement.scrollTop >= headeroffset &&
          document.documentElement.scrollTop <= headeroffset + (container.value as HTMLElement).clientHeight
        ) {
          fixed.value = true;
        } else {
          fixed.value = false;
        }
      }
    };

    // const fixed = computed(() => {
    //   if (fixed.value == true) {
    //     return true;
    //   } else {
    //     return false;
    //   }
    // });

    const init = () => {
      switch (props.type) {
        case 'company':
          store.dispatch('fetchCompanyGrades').then((res) => {
            table.value = res;
            loading.value = false;
          });
          break;
        case 'unit':
          store.dispatch('fetchUnitGrades', props.unit).then((res) => {
            table.value = res;
            loading.value = false;
          });
          break;
        case 'personal':
          store.dispatch('fetchPersonalGrades', props.unit).then((res: any) => {
            barTable.value = res;
            loading.value = false;
          });
          break;
      }
    };

    onMounted(() => {
      store.dispatch('setCompareFilter', []);
      document.addEventListener('scroll', scrollhandler);
      //calcoffsets();
      init();
    });

    onUnmounted(() => {
      store.dispatch('setCompareFilter', []);
      document.removeEventListener('scroll', scrollhandler);
    });

    // watch(props, () => {
    //   init();
    // });
    const mitt = inject('emitter') as Emitter<{ awayfromdetails: string }>;
    const filteredBarTable = computed(() => {
      const table: { [propType: string]: { value: number; target: number; history: number } } = {};
      for (const index in barTable.value) {
        const item = barTable.value[index];

        switch (barTableFilter.value) {
          case 'avg':
            mitt.emit('awayfromdetails', '');
            table[index] = { value: item.value || 0, target: item.target || 0, history: item.history || -1 };
            break;
          case 'manager':
            mitt.emit('awayfromdetails', '');
            table[index] = { value: item.leader || 0, target: item.target || 0, history: item.history || -1 };
            break;
          case 'set':
            mitt.emit('awayfromdetails', '');
            table[index] = { value: item.set || 0, target: item.target || 0, history: item.history || -1 };
            break;
          case 'self':
            mitt.emit('awayfromdetails', '');
            table[index] = { value: item.self || 0, target: item.target || 0, history: item.history || -1 };
            break;
          default:
            table[index] = {
              value: item.detailed ? item.detailed[parseInt(barTableFilter.value)] : 0,
              target: item.target || 0,
              history: item.history || -1,
            };
            break;
        }
      }

      return table;
    });

    const gradingusers = computed(() => {
      if (store.getters.hasPerm('user.all.manage') || store.getters.hasPerm('user.allbutceo.manage') || store.getters.hasPerm('user.unit.manage')) {
        const graders: Array<any> = [];
        for (const index in barTable.value) {
          const grade = barTable.value[index];
          if (grade.detailed) {
            for (const grader in grade.detailed) {
              if (grader != 'history') {
                if (!graders.includes(parseInt(grader))) graders.push(parseInt(grader));
              }
            }
          }
        }

        return graders;
      }
      return [];
    });

    const filterTable = (filter: string) => {
      if (filter == '-1') {
        barTableFilter.value = 'avg';
      } else {
        barTableFilter.value = filter;
      }
    };

    const matrixTable = computed(() => {
      return table.value.result;
    });
    const matrixLabels = computed(() => {
      const filter = store.getters.getCompareFilter;
      if (filter.length > 0) {
        return table.value.labels.filter((item: any) => filter.includes(item.id)) || [];
      } else {
        return table.value.labels || [];
      }
    });

    const slicedMatrixLabels = computed(() => matrixLabels.value?.slice(sliceoffset.value, sliceoffset.value + 6));

    const sumoffset = computed(() => {
      return 6 - (matrixLabels.value?.length || 0);
    });

    const left = () => {
      if (sliceoffset.value > 0) {
        sliceoffset.value--;
      }
    };
    const right = () => {
      if (sliceoffset.value < (matrixLabels.value?.length || 0) - 6) {
        sliceoffset.value++;
      }
    };

    const showScroller = computed(() => (matrixLabels.value?.length || 0) > 6);

    const onMouseOver = (id: number) => {
      hovered.value = id;
    };

    const onMouseLeave = () => {
      hovered.value = -1;
    };

    const navigate = (id: number) => {
      switch (props.type) {
        case 'company':
          store.dispatch('setCompareFilter', []);
          router.push({ name: 'OverviewUnit', params: { id } });
          break;
        case 'unit':
          store.dispatch('setCompareFilter', []);
          router.push({ name: 'OverviewPersonal', params: { id } });
      }
    };

    const showLegend = ref(false);
    const toggleLegend = () => {
      showLegend.value = !showLegend.value;
    };

    return {
      onMouseOver,
      onMouseLeave,
      hovered,
      filteredBarTable,
      matrixTable,
      slicedMatrixLabels,
      showScroller,
      mdiArrowLeft,
      mdiArrowRight,
      sumoffset,
      left,
      right,
      sliceoffset,
      navigate,
      filterTable,
      barTableFilter,
      table,
      header,
      fixed,
      container,
      loading,
      toggleLegend,
      showLegend,
      gradingusers,
    };
  },
});
</script>
